import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, inject, input } from '@angular/core';
import { MenuStateService } from '@app/services/menu-state.service';
import { ModalService } from '@app/components/modal/modal.service';
import { RedDotComponent } from '@app/version/red-dot.component';
import { ReleaseNotesComponent } from '../release-notes.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-trigger-release-notes',
  imports: [CommonModule, TranslocoPipe, RedDotComponent],
  templateUrl: './trigger-release-notes.component.html',
  styleUrl: './trigger-release-notes.component.scss',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class TriggerReleaseNotesComponent {
  updatesAvailable = input<boolean>(false);
  buttonClass = input<string>('');
  modalService = inject(ModalService);
  menuStateService = inject(MenuStateService);

  toggleReleaseNotes() {
    if (this.menuStateService.releaseNotesOpen()) this.menuStateService.toggleReleaseNotes(false);
    this.modalService.open(ReleaseNotesComponent, {}, { screen: 'aside', showCloseButton: false});

    this.menuStateService.toggleMobileUserMenu(false);
  }
}
